import { QuantitySelectorComponent } from '@theme/component-quantity-selector';

/**
 * A custom element that allows the user to select a quantity in the cart.
 * Extends QuantitySelectorComponent but uses absolute max limits instead of effective max.
 * Semantics: "What should the total quantity BE in the cart" vs "How many to ADD to cart"
 *
 * @extends {QuantitySelectorComponent}
 */
class CartQuantitySelectorComponent extends QuantitySelectorComponent {
  /**
   * Gets the effective maximum value for cart quantity selector
   * Cart page: uses absolute max (how much can be in cart total)
   * @returns {number | null} The effective max, or null if no max
   */
  getEffectiveMax() {
    const { max } = this.getCurrentValues();
    return max; // Cart uses absolute max, not max minus cart quantity
  }

  /**
   * Updates button states based on current value and limits
   * Cart buttons are always managed client-side, never server-disabled
   *
   * User-Wunsch: Minus-Button NIE disabled — bei value === 1 entfernt
   * der Klick die ganze Line, statt nichts zu tun.
   */
  updateButtonStates() {
    const { minusButton, plusButton } = this.refs;
    const { value } = this.getCurrentValues();
    const effectiveMax = this.getEffectiveMax();

    minusButton.disabled = false; // immer klickbar — Wert 1 → Line entfernen
    plusButton.disabled = effectiveMax !== null && value >= effectiveMax;
  }

  /**
   * Override: Wenn aktuelle Quantity 1 ist UND der User auf Minus klickt,
   * entfernen wir die Cart-Line komplett (statt am Min-Limit zu blockieren).
   * @param {Event} event
   */
  decreaseQuantity(event) {
    if (!(event.target instanceof HTMLElement)) return;
    const { value, min } = this.getCurrentValues();

    if (value <= min) {
      event.preventDefault();
      this.removeCartLine();
      return;
    }

    // Default-Verhalten erben
    super.decreaseQuantity(event);
  }

  /**
   * Findet den zugehörigen Remove-Button in derselben Cart-Row und
   * klickt ihn — der Button ist im Liquid mit on:click="/onLineItemRemove/N"
   * konfiguriert und triggert die Shopify-AJAX-Remove-Action.
   */
  removeCartLine() {
    // Suche im nächsten `.cart-items__quantity-controls` Container
    // den Remove-Button (.cart-items__remove). Fallback: Sibling-Lookup.
    const controls = this.closest('.cart-items__quantity-controls');
    let removeButton = controls?.querySelector('.cart-items__remove');

    if (!removeButton) {
      // Fallback: bis zur Cart-Row hochlaufen und dort suchen
      const row = this.closest('.cart-items__table-row, .cart-items__nested-line, tr');
      removeButton = row?.querySelector('.cart-items__remove');
    }

    if (removeButton instanceof HTMLElement) {
      removeButton.click();
    }
  }
}

if (!customElements.get('cart-quantity-selector-component')) {
  customElements.define('cart-quantity-selector-component', CartQuantitySelectorComponent);
}
